module.exports = __webpack_public_path__ + "static/media/grommet-icons_location.ed2aac33.svg";